import IRepresentativeRepository from 'domain/interfaces/repositories/IAuthUserRepository'
import { AuthLoginRepresentativeRequest } from 'domain/entities/authUser'

export const LoginRepresentativeCommand = (
  repository: IRepresentativeRepository,
  data: AuthLoginRepresentativeRequest,
) => {
  return repository.login(data)
}
